/*************  TILLFÄLLIGT BYTA UT ALLA LÄNKAR TILL BOKA.KLOSTERHOTEL.SE /*************/


// Hämta alla a-taggar på sidan
//const links = document.querySelectorAll('a');

// Loopa igenom varje länk
//links.forEach(link => {
//    // Kontrollera om href innehåller "boka.klosterhotel.se"
//    if (link.href.includes('boka.klosterhotel.se')) {
//        // Byt ut href till den nya länken
//        link.href = 'https://www.klosterhotel.se/weekend/onlinebokning-tillfälligt-stängd/';
//    }
//});


/*************  TOP-MENU SET ACTIVE /*************/

$(function () {
  if (location.pathname != "/") {
    // first set active to all that match url
    $(".main-navbar .navbar-nav a[href='" + location.href + "']").each(function () {
      var url = $(this).attr("href");
      if ($(this).hasClass("dropdown-toggle")) {
        $(this).parent().addClass('active');
      } else {
        $(this).addClass('active');
      }
    });
    // then set parent dropdown-toggle to active
    $(".main-navbar .active").each(function () {
      $(this).closest(".dropdown").addClass('active');
    });
  }
});


/*************  TOP-MENU SHOW SEARCH  /*************/



$(function () {
  $(".main-navbar .search-trigger").click(function (e) {
    $(".main-navbar .search-form-wrapper").toggle();
    return false;
  });
});


/*************  TOP-MENU SET NOW-STICKY /*************/

$(function () {
  var navbar = $(".main-navbar").first();
  var initialNavbarStartPos = navbar.position().top;
  var initialNavbarEndPos = initialNavbarStartPos + navbar.outerHeight(true);
  $(window).on('scroll', () => {
    var winPos = $(window).scrollTop();
    if (winPos > initialNavbarEndPos + 1) {
      if ($(".main-navbar").hasClass("now-sticky") == false) {
        $(".main-navbar").css("opacity", "0");
        //$(".main-navbar").hide();
        $(".main-navbar").removeClass("scrolled-back-to-top");
        $(".main-navbar").addClass("now-sticky");
        $(".main-navbar").fadeTo(250, 1);
      }
    } else if ($(window).scrollTop() < initialNavbarStartPos) {
      if ($(".main-navbar").hasClass("now-sticky") == true) {

        $(".main-navbar").removeClass("now-sticky");
        $(".main-navbar").addClass("scrolled-back-to-top");
      }
    }
  });
  $(window).trigger('scroll');
});

/*************  TRIGGER SUBMENU WHEN LINK IS # /*************/




/*************  REPLACE ALL BACKVGROUND-IMAGES WHEN NO SUPPORT FOR WEBP /*************/

$("#button").click(function () {
  $('html, body').animate({
    scrollTop: $("#myDiv").offset().top
  }, 2000);
});


/*************  SKIP TO NEXT /*************/

$(function () {
  $(".skip-to-next").click(function () {
    document
      .getElementById("skip-to-next-anchor")
      .scrollIntoView({ behavior: "smooth" });
  });
});

/*************  SET HEIGHT IN MODULE TESTIMONAILS  /*************/


$(function () {

  if ($(".m-testimonials .carousel-item").length) {
    var refreshIntervalId = setInterval(function () {
      var minHeight = 0;
      $(".m-testimonials .carousel-item").each(function () {

        if ($(this).height() > minHeight) {
          minHeight = $(this).height();
        }
      });
      minHeight = minHeight;
      $(".m-testimonials .carousel-item").each(function () {
        $(this).css("min-height", minHeight)
      });
    }, 1000);
  }

});

/**
 * DAILY INFO WIDGET (Händer idag)
 */
$(function () {
  $(".m-dailyInfo").each(function () {
    var $module = $(this);
    var $carousel = $module.find(".carousel");
    if (!$carousel.length) return;

    var todayStr = $module.data("today");
    var today = todayStr ? new Date(todayStr + "T00:00:00") : new Date();
    today.setHours(0, 0, 0, 0);

    function findLastHeadingIn(root) {
      if (!root) return null;
      if (root.matches && (root.matches("h1") || root.matches("h2"))) {
        return root;
      }
      var headings = root.querySelectorAll ? root.querySelectorAll("h1, h2") : [];
      if (!headings.length) return null;
      return headings[headings.length - 1];
    }

    function findPreviousHeading(startEl) {
      var node = startEl;
      while (node) {
        var prev = node.previousElementSibling;
        while (prev) {
          var heading = findLastHeadingIn(prev);
          if (heading) return heading;
          prev = prev.previousElementSibling;
        }
        node = node.parentElement;
      }
      return null;
    }

    var headingEl = findPreviousHeading($module.get(0));
    var formatter = new Intl.DateTimeFormat("sv-SE", {
      weekday: "long",
      day: "numeric",
      month: "long"
    });

    function isSameDay(a, b) {
      return a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();
    }

    function updateHeading(dateStr) {
      if (!headingEl || !dateStr) return;
      var date = new Date(dateStr + "T00:00:00");
      var tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      if (isSameDay(date, today)) {
        headingEl.textContent = "Händer idag";
        return;
      }
      if (isSameDay(date, tomorrow)) {
        headingEl.textContent = "Händer imorgon";
        return;
      }
      headingEl.textContent = "Händer " + formatter.format(date);
    }

    function formatLabel(date, isNext) {
      var tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      var base;

      if (isSameDay(date, today)) {
        base = "Händer idag";
      } else if (isSameDay(date, tomorrow)) {
        base = "Händer imorgon";
      } else {
        base = "Händer " + formatter.format(date);
      }

      return isNext ? (base + " >>") : ("<< " + base);
    }

    function updateControls() {
      var $items = $carousel.find(".carousel-item");
      var total = $items.length;
      if (!total) return;

      var $active = $items.filter(".active").first();
      var index = $items.index($active);
      var dateStr = $active.data("date");
      var isToday = dateStr && todayStr && dateStr === todayStr;
      var $prevBtn = $module.find(".dailyinfo-prev");
      var $nextBtn = $module.find(".dailyinfo-next");

      if (index > 0 && !isToday) {
        var prevDateStr = $items.eq(index - 1).data("date");
        var prevDate = new Date(prevDateStr + "T00:00:00");
        $prevBtn.text(formatLabel(prevDate, false)).show();
      } else {
        $prevBtn.hide();
      }

      if (index < total - 1) {
        var nextDateStr = $items.eq(index + 1).data("date");
        var nextDate = new Date(nextDateStr + "T00:00:00");
        $nextBtn.text(formatLabel(nextDate, true)).show();
      } else {
        $nextBtn.hide();
      }

      updateHeading(dateStr);
    }

    updateControls();
    $carousel.on("slid.bs.carousel", function () {
      updateControls();
    });
  });
});

/*
-------- SET VIDEOSECTION TO HORIZONTAL OR VERTICAL WINDOW
*/

$(function () {

  $(window).on("resize", function () {

    $(".m-videosection").each(function () {

      var width = $(this).width();
      var height = $(this).height();

      if ((height * 16 / 9) < width) {
        $(this).addClass("h-browser");
        $(this).removeClass("v-browser");
      } else {
        $(this).addClass("v-browser");
        $(this).removeClass("h-browser");

      }
    });
  }).resize();
});


/*************  SKAPA AUTOMATISK INNEHÅLLSFÖRTECKNING/ANKARLÄNKAR OM SEKTIONSKLASSEN ÄR TOC /*************/

function buildTocAnchors() {
    const tocSection = document.querySelector('.toc-wrapper');

    if (!tocSection) return;
    const links = tocSection.querySelector('.toc-wrapper .m-links');

    const listContainer = links.querySelector('ul, ol');
    if (!listContainer) return;

    const allH2 = Array.from(document.querySelectorAll('h2'));
    const tocSectionH2 = allH2.filter((heading) => {
        if (tocSection.contains(heading)) return false;
        if (heading.closest('footer')) return false;
        return Boolean(tocSection.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_FOLLOWING);
    });

    tocSectionH2.forEach((heading) => {
        const headingText = heading.textContent.trim();
        if (!headingText) return;
        const tocText = headingText.split(/[-–]/)[0].trim();
        if (!tocText) return;

        // skapa unikt ID för h2:an
        const baseSlug = tocText.toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^\w-]/g, '');
        let anchorId = baseSlug || 'section';
        let count = 1;

        while (document.getElementById(anchorId)) {
            anchorId = `${baseSlug || 'section'}-${count++}`;
        }

        heading.id = anchorId;

        // lägg till länk i listan
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${anchorId}`;
        a.textContent = tocText + ' ↓';

        li.appendChild(a);
        listContainer.appendChild(li);
    });

    tocSection.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', function (e) {
            const targetId = link.getAttribute('href').slice(1);
            const targetEl = document.getElementById(targetId);
            if (!targetEl) return;

            const navbar = document.querySelector('.main-navbar');
            const offset = navbar ? navbar.getBoundingClientRect().height + 20 : 20;
            const top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

            e.preventDefault();
            window.scrollTo({ top: top, behavior: 'smooth' });
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    buildTocAnchors();
});


/*************  ADD SAFARI-MAC /*************/

(function ($) {
  // console.log(navigator.userAgent);
  /* Adjustments for Safari on Mac */
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    // console.log('Safari on Mac detected, applying class...');
    $('html').addClass('safari-mac'); // provide a class for the safari-mac specific css to filter with
  }
})(jQuery);

/*************  EXPANDABLE /*************/

$(function () {

  $(".m-expandable .toggle-title").click(function () {
    $parent = $(this).closest(".m-expandable");
    $content = $parent.find(".toggle-content");
    $parent.toggleClass("active");
    $content.slideToggle(500, function () { });
    return false;
  });
});

/*************  PACKAGES FILTER  /*************/

document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.m-packages')) return;
  const filters = Array.from(document.querySelectorAll('[data-packages-filter]'));
  if (!filters.length) return;

  filters.forEach((filter) => {
    const targetClass = filter.getAttribute('data-packages-target');
    const listEl = targetClass ? document.querySelector(`.${CSS.escape(targetClass)}`) : null;
    const items = listEl ? Array.from(listEl.querySelectorAll('.package')) : [];
    const areaButtons = Array.from(filter.querySelectorAll('[data-area-id]'));
    const featureButtons = Array.from(filter.querySelectorAll('[data-feature-id]'));
    const overnightButtons = Array.from(filter.querySelectorAll('[data-overnight]'));

    if (!items.length || (!areaButtons.length && !featureButtons.length && !overnightButtons.length)) return;

    const paramSuffix = (targetClass || '').replace(/^module-/, '') || 'packages';
    const paramKey = (base) => `${base}_${paramSuffix}`;

    const applyFilter = (selectedAreaIds, selectedFeatureIds, selectedOvernight) => {
      items.forEach((item) => {
        const itemAreaIds = (item.dataset.areas || '')
          .split(/\s+/)
          .filter(Boolean);
        const itemIds = (item.dataset.features || '')
          .split(/\s+/)
          .filter(Boolean);
        const areaMatches = selectedAreaIds.length === 0 || selectedAreaIds.some((id) => itemAreaIds.includes(id));
        const featureMatches = selectedFeatureIds.length === 0 || selectedFeatureIds.some((id) => itemIds.includes(id));
        const overnightMatches = !selectedOvernight || (item.dataset.overnight || '') === selectedOvernight;
        const matches = areaMatches && featureMatches && overnightMatches;
        item.classList.toggle('is-filtered-out', !matches);
      });
    };

    const updateFeatureAvailability = (selectedAreaIds, selectedOvernight, selectedFeatureIds) => {
      if (!featureButtons.length) return;
      const availableFeatureIds = new Set();
      items.forEach((item) => {
        const itemAreaIds = (item.dataset.areas || '')
          .split(/\s+/)
          .filter(Boolean);
        const itemFeatureIds = (item.dataset.features || '')
          .split(/\s+/)
          .filter(Boolean);
        const areaMatches = selectedAreaIds.length === 0 || selectedAreaIds.some((id) => itemAreaIds.includes(id));
        const overnightMatches = !selectedOvernight || (item.dataset.overnight || '') === selectedOvernight;
        if (areaMatches && overnightMatches) {
          itemFeatureIds.forEach((id) => availableFeatureIds.add(id));
        }
      });

      featureButtons.forEach((button) => {
        const id = button.getAttribute('data-feature-id');
        const isActive = selectedFeatureIds.includes(id);
        const isAvailable = availableFeatureIds.has(id);
        const shouldHide = !isActive && !isAvailable;
        const item = button.closest('.filter-item');
        if (item) {
          item.classList.toggle('is-filter-hidden', shouldHide);
        }
      });
    };

    const setActiveButtons = (selectedAreaIds, selectedFeatureIds, selectedOvernight) => {
      areaButtons.forEach((button) => {
        const id = button.getAttribute('data-area-id');
        const isActive = selectedAreaIds.includes(id);
        button.classList.toggle('is-active', isActive);
      });
      featureButtons.forEach((button) => {
        const id = button.getAttribute('data-feature-id');
        const isActive = selectedFeatureIds.includes(id);
        button.classList.toggle('is-active', isActive);
      });
      overnightButtons.forEach((button) => {
        const value = button.getAttribute('data-overnight') || '';
        const isActive = value === selectedOvernight && value !== '';
        button.classList.toggle('is-active', isActive);
      });
    };

    const updateUrl = (selectedAreaIds, selectedFeatureIds, selectedOvernight) => {
      const params = new URLSearchParams(window.location.search);
      if (selectedAreaIds.length) {
        params.set(paramKey('areas'), selectedAreaIds.join(','));
      } else {
        params.delete(paramKey('areas'));
      }
      if (selectedFeatureIds.length) {
        params.set(paramKey('features'), selectedFeatureIds.join(','));
      } else {
        params.delete(paramKey('features'));
      }
      if (selectedOvernight) {
        params.set(paramKey('overnight'), selectedOvernight);
      } else {
        params.delete(paramKey('overnight'));
      }
      const newUrl = `${window.location.pathname}${params.toString() ? `?${params}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', newUrl);
    };

    const readFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      const rawAreas = params.get(paramKey('areas')) || '';
      const raw = params.get(paramKey('features')) || '';
      const areaIds = rawAreas
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
      const featureIds = raw
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
      const overnight = (params.get(paramKey('overnight')) || '').trim();
      return { areaIds, featureIds, overnight };
    };

    const applyStateFromUrl = () => {
      const state = readFromUrl();
      selectedAreaIds = state.areaIds;
      selectedFeatureIds = state.featureIds;
      selectedOvernight = state.overnight;

      setActiveButtons(selectedAreaIds, selectedFeatureIds, selectedOvernight);
      updateFeatureAvailability(selectedAreaIds, selectedOvernight, selectedFeatureIds);
      applyFilter(selectedAreaIds, selectedFeatureIds, selectedOvernight);
      if (window.applyPackagesInitialLimit) {
        window.applyPackagesInitialLimit(listEl);
      }
    };

    let { areaIds: selectedAreaIds, featureIds: selectedFeatureIds, overnight: selectedOvernight } = readFromUrl();
    applyStateFromUrl();

    areaButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-area-id');
        if (!id) return;
        selectedAreaIds = selectedAreaIds[0] === id ? [] : [id];
        setActiveButtons(selectedAreaIds, selectedFeatureIds, selectedOvernight);
        applyFilter(selectedAreaIds, selectedFeatureIds, selectedOvernight);
        if (window.applyPackagesInitialLimit) {
          window.applyPackagesInitialLimit(listEl);
        }
        updateUrl(selectedAreaIds, selectedFeatureIds, selectedOvernight);
      });
    });

    featureButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-feature-id');
        if (!id) return;
        selectedFeatureIds = selectedFeatureIds[0] === id ? [] : [id];
        setActiveButtons(selectedAreaIds, selectedFeatureIds, selectedOvernight);
        applyFilter(selectedAreaIds, selectedFeatureIds, selectedOvernight);
        if (window.applyPackagesInitialLimit) {
          window.applyPackagesInitialLimit(listEl);
        }
        updateUrl(selectedAreaIds, selectedFeatureIds, selectedOvernight);
      });
    });

    overnightButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.getAttribute('data-overnight') || '';
        if (!value) return;
        selectedOvernight = selectedOvernight === value ? '' : value;
        setActiveButtons(selectedAreaIds, selectedFeatureIds, selectedOvernight);
        updateFeatureAvailability(selectedAreaIds, selectedOvernight, selectedFeatureIds);
        applyFilter(selectedAreaIds, selectedFeatureIds, selectedOvernight);
        if (window.applyPackagesInitialLimit) {
          window.applyPackagesInitialLimit(listEl);
        }
        updateUrl(selectedAreaIds, selectedFeatureIds, selectedOvernight);
      });
    });

    window.addEventListener('popstate', () => {
      applyStateFromUrl();
    });
  });
});

/*************  PACKAGES SHOW MORE  /*************/

document.addEventListener('DOMContentLoaded', function () {
  const containers = Array.from(document.querySelectorAll('.m-packages'));
  if (!containers.length) return;

  const hydratePackageImage = (item) => {
    const link = item.querySelector('a.image-wrapper');
    if (!link || link.querySelector('img')) return;
    const webp = link.dataset.imageWebp;
    const jpg = link.dataset.imageJpg;
    if (!webp && !jpg) return;

    const picture = document.createElement('picture');

    if (webp) {
      const sourceWebp = document.createElement('source');
      sourceWebp.type = 'image/webp';
      sourceWebp.srcset = webp;
      picture.appendChild(sourceWebp);
    }

    if (jpg) {
      const sourceJpg = document.createElement('source');
      sourceJpg.type = 'image/jpeg';
      sourceJpg.srcset = jpg;
      picture.appendChild(sourceJpg);
    }

    const img = document.createElement('img');
    img.src = jpg || webp;
    img.alt = link.dataset.imageAlt || '';
    const width = link.dataset.imageWidth;
    const height = link.dataset.imageHeight;
    if (width) img.width = Number.parseInt(width, 10);
    if (height) img.height = Number.parseInt(height, 10);
    picture.appendChild(img);

    link.insertBefore(picture, link.firstChild);
  };

  window.applyPackagesInitialLimit = (listEl) => {
    if (!listEl) return;
    const container = listEl.closest('.m-packages');
    if (!container) return;
    const limit = Number.parseInt(container.dataset.initialLimit || '0', 10);
    if (!limit) return;
    if (container.dataset.expanded === 'true') return;

    const visibleItems = Array.from(listEl.querySelectorAll('.package'))
      .filter((item) => !item.classList.contains('is-filtered-out'));

    visibleItems.forEach((item, index) => {
      if (index < limit) {
        item.classList.remove('is-initially-hidden');
        hydratePackageImage(item);
      } else {
        item.classList.add('is-initially-hidden');
      }
    });

    const button = container.querySelector('.load-more button');
    if (button) {
      button.style.display = visibleItems.length > limit ? '' : 'none';
    }
  };

  containers.forEach((container) => {
    const listEl = container.querySelector('.packages');
    const button = container.querySelector('.load-more button');
    if (!listEl) return;

    window.applyPackagesInitialLimit(listEl);

    if (!button) return;

    button.addEventListener('click', () => {
      container.dataset.expanded = 'true';
      const items = Array.from(listEl.querySelectorAll('.package'))
        .filter((item) => !item.classList.contains('is-filtered-out'));

      items.forEach((item) => {
        item.classList.remove('is-initially-hidden');
        hydratePackageImage(item);
      });

      button.style.display = 'none';
    });
  });
});




/*************  OPEN EXTERNAL LINKS IN NEW WINDOW /*************/


$(function () {
  $('a').each(function () {
    var openLinkInNewWindow2 = openLinkInNewWindow($(this));
    if (openLinkInNewWindow2) {
      $(this).prop('target', '_blank');
    }

  });
});


function openLinkInNewWindow(element) {
  var href = element.attr("href");
  if ((/^\//.test(href))) {
    return false;
  }
  if (!href || href.startsWith('javascript:')) {
    return false;
  }
  if (/^https:\/\/klosterhotel\./.test(href)) {
    return false;
  }
  if (/^http:\/\/klosterhotel\./.test(href)) {
    return false;
  }
  if (/^https:\/\/kh.style4/.test(href)) {
    return false;
  }
  if (/^https:\/\/www.klosterhotel\./.test(href)) {
    return false;
  }
  if (/^https:\/\/klosterhotel\./.test(href)) {
    return false;
  }
  if (/^https:\/\/online.bookvisit\.com/.test(href)) {
    return false;
  }
  if (/^https:\/\/boka.klosterhotel\.se/.test(href)) {
    return false;
  }
  // trigga inte nytt fönster för https://xx.klosterhotel.se/...
  if (/^https?:\/\/[a-z]{2}\.klosterhotel\.se\b/i.test(href)) {
    return false;
  }
  if (/\.pdf$/.test(href)) {
    return false;
  }
  if (/\.doc$/.test(href)) {
    return false;
  }
  if (/\.xls$/.test(href)) {
    return false;
  }
  if (/\.ppt$/.test(href)) {
    return false;
  }
  if (/^mailto:/.test(href)) {
    return false;
  }
  if (/^tel:/.test(href)) {
    return false;
  }
  if (/^#/.test(href)) {
    return false;
  }

  return true;
}


/*************  Sätt langid på alla länkar till boka.klosterhotel.se vid sidladdning  *************/
(function () {
  // Mappning subdomän → langid i BookVisit
  const LANGID_MAP = { en: '2', de: '3', da: '4', nb: '5' };
  const FORCE_LANGID = null; // null för att stänga av och exempelvis 2 för engelska

  function getLangIdFromHost(hostname) {
    const LANGID_MAP = { en:'2', de:'3', da:'4', nb:'5' };
    if (FORCE_LANGID) return FORCE_LANGID;            // ⟵ dev-override
    const m = hostname.toLowerCase().match(/^([a-z]{2})\.klosterhotel\.se$/i);
    if (!m) return null;
    return LANGID_MAP[m[1]] || null;
  }

  const langid = getLangIdFromHost(location.hostname);
  if (!langid) return; // inte på språk-subdomän → gör inget

  function addLangIdIfNeeded(link) {
    if (!link || link.hasAttribute('data-langid-optout')) return;

    let urlObj;
    try {
      // Använd link.href (absolut URL) för robusthet
      urlObj = new URL(link.href, location.href);
    } catch {
      return; // ogiltig URL
    }

    if (urlObj.hostname !== 'boka.klosterhotel.se') return;

    // Sätt eller uppdatera langid, utan att radera andra parametrar
    if (urlObj.searchParams.get('langid') !== langid) {
      urlObj.searchParams.set('langid', langid);
      // Skriv tillbaka absolut URL; browsers visar ändå relativt i DOM om så var från början
      link.href = urlObj.toString();
    }
  }

  function processAllLinks(root = document) {
    root.querySelectorAll('a[href]').forEach(addLangIdIfNeeded);
  }

  // Kör när DOM är redo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => processAllLinks());
  } else {
    processAllLinks();
  }

  // Fånga dynamiskt tillagda/ändrade länkar
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // Nya noder
      m.addedNodes && m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'A' && node.hasAttribute('href')) addLangIdIfNeeded(node);
        else processAllLinks(node);
      });
      // Ändrat href på befintlig länk
      if (m.type === 'attributes' && m.target && m.target.tagName === 'A' && m.attributeName === 'href') {
        addLangIdIfNeeded(m.target);
      }
    }
  });
  mo.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['href']
  });
})();

/*************  FUNCTION SHOW POPUP  /*************/

(function () {

  var $campaignPopup = $('#campaign-popup');
  var hasCampaign = $campaignPopup.length > 0;
  var campaignId = hasCampaign ? $campaignPopup.data('popup-id') : null;
  var popupVersion = hasCampaign ? ($campaignPopup.data('popup-version') || 1) : 1;
  var frequency = hasCampaign ? ($campaignPopup.data('frequency') || 'monthly') : 'monthly';
  var isTestMode = hasCampaign ? $campaignPopup.data('test-mode') === 1 : false;
  var trigger = hasCampaign ? ($campaignPopup.data('trigger') || 'delay5') : 'delay5';

  /**
   * Map frequency value to hours.
   */
  function frequencyToHours(freq) {
    switch (freq) {
      case 'once':     return 8760;  // 1 year
      case 'weekly':   return 168;   // 7 days
      case 'monthly':  return 730;   // ~1 month
      case 'halfyear': return 4380;  // ~6 months
      default:         return 730;
    }
  }

  /**
   * Check if a popup was already shown (via localStorage timestamp).
   * Returns true if it should be suppressed.
   */
  function isAlreadyShown(key) {
    if (!window.localStorage) return false;
    var nextPopup = localStorage.getItem(key);
    return nextPopup && nextPopup > new Date();
  }

  /**
   * Mark a popup as shown for a given number of hours.
   */
  function markAsShown(key, hours) {
    if (!window.localStorage) return;
    var expires = new Date();
    expires = expires.setHours(expires.getHours() + hours);
    localStorage.setItem(key, expires);
  }

  /**
   * Show the campaign popup if available and not already shown.
   * Returns true if the campaign popup was shown.
   */
  function tryShowCampaignPopup() {
    if (!hasCampaign) return false;

    var storageKey = 'popup_' + campaignId + '_v' + popupVersion;

    // In test mode, always show (skip localStorage check).
    if (!isTestMode && isAlreadyShown(storageKey)) {
      return false;
    }

    // Don't show if another modal is already open.
    if ($('.modal.show').length > 0) return false;

    if (!isTestMode) {
      markAsShown(storageKey, frequencyToHours(frequency));
    }

    $campaignPopup.modal('show');
    return true;
  }

  /**
   * Show the newsletter popup if not already shown and no other modal is open.
   */
  function tryShowNewsletterPopup() {
    if (isAlreadyShown('newsletter')) return false;

    // Don't show if another modal is already open.
    if ($('.modal.show').length > 0) return false;

    markAsShown('newsletter', 8760); // 1 year
    $('#newsletter-modal').modal('show');
    return true;
  }

  /**
   * Try campaign popup first, then newsletter as fallback.
   */
  function showPopup() {
    var shown = tryShowCampaignPopup();
    if (!shown) {
      tryShowNewsletterPopup();
    }
  }

  /**
   * Trigger: time-based delay (delay2, delay5, delay10).
   */
  function initDelayTrigger(ms) {
    setTimeout(function () {
      showPopup();
    }, ms);
  }

  /**
   * Trigger: scroll-up detection.
   * Fires when the visitor scrolls upward by at least 50px.
   */
  function initScrollUpTrigger() {
    var lastScrollTop = $(window).scrollTop();
    var scrollUpAccumulated = 0;
    var threshold = 50; // Minimum upward scroll in pixels.

    $(window).on('scroll.popup_trigger', function () {
      var currentScroll = $(window).scrollTop();
      var diff = lastScrollTop - currentScroll;

      if (diff > 0) {
        // Scrolling up.
        scrollUpAccumulated += diff;

        if (scrollUpAccumulated >= threshold) {
          $(window).off('.popup_trigger');
          showPopup();
        }
      } else {
        // Scrolling down – reset accumulator.
        scrollUpAccumulated = 0;
      }

      lastScrollTop = currentScroll;
    });
  }

  // Determine which trigger to use.
  // Campaign popup: use the configured trigger.
  // No campaign: fall back to 5 s delay for the newsletter popup.
  if (hasCampaign) {
    switch (trigger) {
      case 'delay2':
        initDelayTrigger(2000);
        break;
      case 'delay10':
        initDelayTrigger(10000);
        break;
      case 'scrollup':
        initScrollUpTrigger();
        break;
      case 'delay5':
      default:
        initDelayTrigger(5000);
        break;
    }
  } else {
    initDelayTrigger(5000);
  }

})();

$(function () {
  // Lazy-load newsletter iframe when modal opens.
  $('#newsletter-modal').on('shown.bs.modal', function () {
    $('#newsletter-modal iframe').each(function () {
      $(this).renameAttr('data-src', 'src');
    });
  });
});


/*************  FUNCTIONS  /*************/

jQuery.fn.extend({
  renameAttr: function (name, newName, removeData) {
    var val;
    return this.each(function () {
      val = jQuery.attr(this, name);
      jQuery.attr(this, newName, val);
      jQuery.removeAttr(this, name);
      // remove original data
      if (removeData !== false) {
        jQuery.removeData(this, name.replace('data-', ''));
      }
    });
  }
});



/*
-------- BG-VIDEO-CONTAINER (FOR COLUMN)
*/

$(function () {

  $(window).on("resize", function () {
    $(".m-col>.bg-video-container").each(function () {
      var parent = $(this).parent();
      var parentContainer = parent.parent().parent();
      parentPaddingLeft = parseInt(parent.css("padding-left"));
      parentPaddingright = parseInt(parent.css("padding-right"));
      totalPadding = parentPaddingLeft + parentPaddingright;

      $(this).css("margin-left", -parentPaddingLeft);
      $(this).css("width", "calc(100% + " + totalPadding + "px)");

      var iframe = $(this).find("iframe");

      if ($(this).width() > $(window).width() * 0.9) { // if only one column width (mobile-mode)
        $(this).css("padding-bottom", "calc(56.25% + " + parentPaddingLeft + "px)");
        $(this).addClass("mobile-mode");
      } else {
        $(this).removeClass("mobile-mode");
        var height = $(this).height();
        iframe.css("width", "calc(" + height + "px * 16 / 9)");
      }

      iframe.show();

    });
  }).resize();
});

/* bestämmer om tillbaka-länkar ska sparas */
document.addEventListener('DOMContentLoaded', () => {
  const activeRoots = window.backlinkActiveRoots || [];            /* ❷ */

  document.body.addEventListener('click', e => {
    const link = e.target.closest('a');
    if (!link || !link.href) return;

    const dest = new URL(link.href, location.href);
    if (dest.origin !== location.origin) return;

    const inNavbar = link.closest('.main-navbar') !== null || link.dataset.nav === '1';
    if (inNavbar) {
      sessionStorage.removeItem('back_prevUrl');
      sessionStorage.removeItem('back_prevTitle');
      return;
    }

    /* Spara bara om den sida man lämnar TILLHÖR en aktiv gren */
    const curSec = location.pathname.split('/')[1] || '';
    if (!activeRoots.includes(curSec)) return;                     /* ❷ */

    sessionStorage.setItem('back_prevUrl', location.href);
    const m = document.querySelector('meta[name="entry-title"]');
    sessionStorage.setItem('back_prevTitle', m ? m.content : document.title);
  });
});

/* Vegas slideshow on sections */

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("script.vegas-config").forEach(function (el) {
    try {
      const slides = JSON.parse(el.textContent);
      const target = el.dataset.target;

      if (slides.length > 0 && document.querySelector(target)) {
        document.querySelector(target).classList.add("vegas-initialized");
        $(target).vegas({
          slides: slides,
          delay: 5000,
          transition: "fade",
          timer: false,
          transitionDuration: 1000,
          animation: 'kenburns'
        });
      }
    } catch (err) {
      console.warn("Kunde inte initiera Vegas:", err);
    }
  });
});

/*************  Module bookvisitPackage /*************/

$(function () {
  // 1. Finns ingen m-bookvisit-package → gör ingenting
  var $modules = $('.m-bookvisit-package');
  if (!$modules.length) {
    return;
  }

  // 2. För varje modul (om du skulle ha fler på samma sida)
  $modules.each(function () {
    var $module = $(this);
    var $select = $module.find('select');

    $select.on('change', function () {
      var packageId = $(this).val();

      // Säkerhetskoll
      if (!packageId || typeof BV === 'undefined' || typeof BV.SPWidget !== 'function') {
        return;
      }

      // 3. Uppdatera paket-id i config
      config.packageId = packageId;

      // 4. Töm widgetcontainern
      $('#widgetContainer').empty();

      // 5. Rendera om widgeten
      BV.SPWidget(Object.assign({}, config));
      // eller: BV.SPWidget({ ...config }) om du bara kör moderna browsers
    });
  });
});
